<template>
	<div class="fc-edit-detail">
		<label>Change Password</label>
		<form>
			<div>
				<label><span>*</span>RECENT PASSWORD</label>
				<input v-model="password.RecentPassword" type="text" />
			</div>
			<div>
				<label><span>*</span>NEW PASSWORD</label>
				<input v-model="password.NewPassword" type="text" />
			</div>
			<div>
				<label><span>*</span>CONFIRM NEW PASSWORD</label>
				<input v-model="password.ConfirmedPassword" type="text" />
			</div>
			<div>
				<a @click="editCustomer">CHANGE PASSWORD</a>
			</div>
		</form>
	</div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'editpassword',
  created () {
    this.password = {
      RecentPassword: '',
      NewPassword: '',
      ConfirmedPassword: ''
    }
  },
  methods: {
    editCustomer () {
      if (process.browser) {
        if (this.password.RecentPassword === '' || this.password.NewPassword === '' || this.password.ConfirmedPassword === '') {
          $.alert({
            title: 'Notice',
            content: 'Please input your password',
            type: 'orange',
            useBootstrap: false
          })
          return
        }
        if (this.password.NewPassword !== this.password.ConfirmedPassword) {
          $.alert({
            title: 'Notice',
            content: 'New password not equal to confirmed password',
            type: 'orange',
            useBootstrap: false
          })
          return
        }
      }
      const profile = JSON.parse(JSON.stringify(this.password))
      this.$store.dispatch('customer/editCustomerPassword', profile)
        .then(a => {
          this.$emit('closeEditDetail')
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/profile/ChangePassword.vue